import { render, staticRenderFns } from "./TechnicalPartsOverview.vue?vue&type=template&id=983e687e&"
import script from "./TechnicalPartsOverview.vue?vue&type=script&lang=js&"
export * from "./TechnicalPartsOverview.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalPartsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
